import { createContext } from "react";
import type { Order, OrderUpdateResponse } from "../../../api/orders";
import type { CartItem, DeliveryMethod } from "../utils/types";

export interface OrderContextType {
  orders: Order[];
  loading: boolean;
  error: string | null;
  fetchOrders: () => Promise<void>;
  createOrder: (
    companyRegistrationNumber: string,
    products: CartItem[],
    deliveryMethod: DeliveryMethod,
    totalPrice: number,
  ) => Promise<Order | null>;
  updateStatus: (id: string, status: string) => Promise<OrderUpdateResponse>;
  refreshOrders: () => Promise<void>;
}

export const OrderContext = createContext<OrderContextType>({
  orders: [],
  loading: false,
  error: null,
  fetchOrders: () => Promise.resolve(),
  createOrder: () => Promise.resolve(null),
  updateStatus: async () => {
    throw new Error("OrderContext not initialized");
  },
  refreshOrders: () => Promise.resolve(),
});
